import React,{useState,useEffect} from 'react'
import {Box, TextField, FormControl, Tooltip, LinearProgress,
        Select, MenuItem, InputLabel, InputAdornment, IconButton, Input,
        Typography, FormLabel, RadioGroup, Radio, FormControlLabel} from '@material-ui/core' 
import DateFnsUtils from '@date-io/date-fns'; 
import esLocale from "date-fns/locale/es";
import {DatePicker,MuiPickersUtilsProvider} from '@material-ui/pickers';
import Autocomplete from "@material-ui/lab/Autocomplete";
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Modal from '../generales/ModalCerrarActualiza';
import moment from 'moment'
import MapaAlerta from '../generales/MapaAlerta'
import {llamaApiCargaToken,ErrorGeneral,llamadaApiCarga } from '../funciones/ClienteAxios';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { toast } from 'react-toastify'; 
import MapaLeaf from './MapaLeaf';

const listAfil=[{Id:"1",desc:"Distrito"},{Id:"2",desc:"SubDistrito"},{Id:"3",desc:"OTB"}]

const listSubTipo=[{Id:"1",desc:"Lider"},{Id:"2",desc:"Coordinador"},{Id:"3",desc:"Promotor"} ]

const ModalNvoEdit = ({modalAbierto,setModalAbierto ,titulo,listPart,auxReg,getDatos,}) => {
    let history = useHistory();    
    const fechaMax = moment(new Date()).subtract(18,'years')  
    const nvl= localStorage.getItem('Tipo')?parseInt(localStorage.getItem('Tipo')):0;   
    const usuId =localStorage.getItem('UsuId') ;                
    //const usuDto =localStorage.getItem('UsuDto') ;
    //const usuMun =localStorage.getItem('UsuMun') ? parseInt(localStorage.getItem('UsuMun') ) :0;
    //const usuSec =localStorage.getItem('UsuSec') ?parseInt(localStorage.getItem('UsuSec') ):0;
    const [espera,setEspera]= useState(false);
    const[visiblePwd,setVisiblePwd]= useState(false)      
    const [mensaje, setMensaje] = useState("");
    const [tipoAdvertencia, setTipoAdvertencia] = useState("success");
    const [btnDeshabilitado,setBtnDeshabilitado]= useState(false)
    const [aviso, setAviso] = useState(false);
    const[posicion,setPosicion]= useState([])
    const[mensajePos,setMensajePos]= useState("")
    const[cambioEfectivo,serCambioEfectivo] = useState(false)    
    const[nvoRegistro, setNvoRegistro] = useState([])   
    const[listDistrito,setListDistrito]= useState([]);  
    const[listRecinto,setListRecinto]= useState([]);  
    const[listOtb,setListOtb]= useState([]);  
    const[listSecc,setListSecc]= useState([]);  
    const[listNivelTp,setListNivelTp]= useState([]);  
    const[validaPerfil, setValidaPerfil] = useState({perfil:false,nombre:false})  
    const[registro, setRegistro] = useState({Nombre:'', FNacimien:fechaMax, Email:'' ,
        Tel:'', genero:"H", Llave:0, Tipo:"", Edad:0, ApPat:"", ApMat:"", Seccion:"",
        Participo:"0",Partido:null, Distrito:"", Subtipo:"", Otb:"", UsrNom:"", UsrPass:"",
        Recinto:""
    })  
    const{Llave,  Nombre,FNacimien,Email,Tel, Tipo, ApPat, ApMat, Participo, Partido, genero, 
        Distrito, Subtipo, Otb, UsrNom, UsrPass, Recinto,Seccion }=registro
    const[arrError,setArrError] = useState([false,false,false,false,false,false])     
    const source = axios.CancelToken.source();  
    let Dispvo =localStorage.getItem('Dispvo') ;    
    const auxDispV =Dispvo.length >= 12 ? Dispvo:'451224452121'  
    
    useEffect(()=>{    
        if (!auxReg) 
        {             
            getLocation()
        }
        getListDto()
        getListNivel()

        return ()=> {
            source.cancel();
        } 
    },[])

    useEffect(() => {
      
        if (auxReg) 
        {   
            
          /*   setRegistro({...registro,Llave:auxReg.Id, Nombre:auxReg.Nom,
                FNacimien:`${moment.utc(auxReg.FNac).format('YYYY-MM-DD')}T12:00`, Email:auxReg.Email,Tel:auxReg.Tel, 
                Tipo:""+auxReg.Tipo, Subtipo:"", Otb:auxReg.OtbId, UsrNom:auxReg.UsrNom,
                Edad:auxReg.Edad, ApPat:auxReg.Pat, ApMat:auxReg.Mat, genero: auxReg.Genero,
                Participo:`${auxReg.Participo}`, Partido:auxReg.PartId, Distrito:auxReg.DtoId})             */
            setInterval(getListPass(auxReg.Id),500)
            setPosicion({Lat:auxReg.Lat,Lon:auxReg.Lon})
        }
        getListSecc(34)
      
    }, [])

    const getListPass = (Lider) => {
        const data = qs.stringify({
            usuario: usuId, Lider:Lider,  ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "estructura/v1/pass";

        function respuestaSecc(auxiliar) {
            if (auxiliar) {               
                
               setRegistro({...registro, UsrPass:auxiliar.Info,   Llave:auxReg.Id, Nombre:auxReg.Nom,
                FNacimien:`${moment.utc(auxReg.FNac).format('YYYY-MM-DD')}T12:00`, Email:auxReg.Email,Tel:auxReg.Tel, 
                Tipo:auxReg.Tipo, Subtipo:auxReg.SubTipo,   UsrNom:auxReg.Usuario,  Distrito:auxReg.DtoId,
                Edad:auxReg.Edad, ApPat:auxReg.Pat, ApMat:auxReg.Mat, genero: auxReg.Genero,
                Participo:`${auxReg.Participo}`, Partido:auxReg.PartId, Seccion:auxReg.SecId,
               })       
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }
    const getListSecc = (auxMun) => {
        const data = qs.stringify({
            Usuario: usuId,
            ip:"123.123.123.123",
            Municipio:auxMun,
            idDispositivo: 'w8rf51v21dsd2cs',
        });
        const url = "lugar/seccion/municipio";

        function respuesta(response) {
            if (response[0].Id != -1) {
                setListSecc(response)
            }
        }

        llamaApiCargaToken(data, url, respuesta, ErrorGeneral, setEspera, history, source);
    };
              
    const getListDto = () => {
        const data = qs.stringify({
            Usuario: usuId, Estado: 15,  ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "lugar/municipio/distrito";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {               
                let listNvo=[]
                auxiliar.forEach(element => {
                    listNvo.push({...element, cadena:`D${element.Nom}`})
                }); 
                setListDistrito(listNvo)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

    const getListNivel = () => {
        const data = qs.stringify({
            Usuario: usuId, ip:"127.0.0.0", idDispositivo: auxDispV,
        });
        const url = "estructura/v1/nivel";

        function respuestaSecc(auxiliar) {
            if (auxiliar[0].Id != -1) {                               
                setListNivelTp(auxiliar)                
            }
        }

        llamaApiCargaToken(data, url, respuestaSecc, ErrorGeneral, setEspera, history, source);
    }

 
    const guardarFNaci = auxfecha =>
    {   
        setRegistro({
            ...registro,
            FNacimien : auxfecha  
        })
    };

    function getLocation() {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(showPosition);
        } 
        else 
        {  
            setMensajePos( "La Geolocalizacion no es soportada por tu navegador.");
            setPosicion([])
        }
    }
      
    function showPosition(position) {
        let Latitude= position.coords.latitude ;
        let Longitude= position.coords.longitude;        
        setPosicion({Lat:Latitude,Lon:Longitude})
    }

    const RelojFNacimiento = ()=>
    { return <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>            
        <Tooltip title="Seleccionar Fecha Nacimiento">
          <Box  mr={1}  component="span" width={1/4}>           
            <DatePicker style={{width:8.3+'rem'}}
              disableFuture  format="dd/MM/yyyy"
              views={["year", "month", "date"]}
              label="Fecha Nacimiento" size="small"
              openTo="year" cancelLabel={"Cancelar"}                  
              okLabel="Seleccionar"    
              minDate="1900-03-14" maxDate={fechaMax}
              value={FNacimien} onChange={guardarFNaci}            
            />                          
          </Box>    
        </Tooltip>                                             
        </MuiPickersUtilsProvider>
    }

    const onChange = e =>
	{   
        let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$.@#_&-+()/:;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
                && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
                || e.target.value===' '|| e.target.value==='') 
        {
            setRegistro({
                ...registro, 
                [e.target.name] : e.target.value//.toUpperCase()  
            })            
        }		
	};             

    function respuestaDuplicado(auxiliar){        
        const isEmpty = Object.keys(auxiliar).length === 0
        let auxArr=arrError
        if (isEmpty || auxiliar.rechazo===0 ||  auxiliar.rechazo==="0"   ) 
        {   //             
            auxArr[3]=true     
            setArrError(auxArr)                 
            let auxFechaNacimient=moment( FNacimien).format('YYYY-MM-DD')  
            llamadaNvoPerfil(auxFechaNacimient+'T00:00:00')              
        } 
        else 
        {   //let mensaje = "Nombre ya registrado, ingrese un Nombre diferente.";
            let mensaje = auxiliar.mensaje//"Nombre ya registrado, ingrese un Nombre diferente.";
            toast.warning(mensaje,{
                pauseOnFocusLoss: false,                    
                toastId: `nvo-perfil${6}`
            })                                    
            mandaAlerta(mensaje, "warning");
            auxArr=arrError
            auxArr[3]=true                    
            setArrError(auxArr) 
            setBtnDeshabilitado(false)               
        }
    }

    const onChangeNumTel = e =>
	{   let expNopermitida= new RegExp('[A-Za-z$@#_&-+()/:;!?,<>=]');          
        let expMenos = new RegExp("'");
        let expMas = new RegExp('-');     
        let expCadena = new RegExp('[.0-9$]');             
        if (  e.target.value.length<=10 &&( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) 
            && !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) 
            || e.target.value===' '|| e.target.value==='') 
        {
            setRegistro({
                ...registro, 
                [e.target.name] : e.target.value//.toUpperCase()  
            })            
         
        }		    

	}; 
 
    const llamadaNvoPerfil = (auxFechaNacimient,anios) => {                    
        const data = qs.stringify({
            Usuario:usuId,
            Llave:Llave,
            Tipo:Tipo,
            Dto:Tipo === 12 ? Distrito : 0,
            Muni:71,
            Seccion:Seccion,
            Edad:anios,
            FNac:auxFechaNacimient ,         
            Nombre:Nombre,
            Paterno:ApPat,
            Materno:ApMat,
            Tel:Tel,
            Email:Email,
            genero:genero,
            Participo:Participo,
            Partido:Partido?Partido:0,
            Latitud:posicion.length > 0 ? posicion.Lat : 0.0,
            Longitud:posicion.length > 0 ? posicion.Lon : 0.0,
            SubTipo:Subtipo,
            //Otb:Otb,
            UsrNom:UsrNom,
            UsrPass:UsrPass,
           // Recinto:Recinto,
            idDispositivo: auxDispV,
        });
        const url = "estructura/v5/new";
        function respuesta(aux) {
            if (aux.length!==0)
            {   setBtnDeshabilitado(true)                                             
                const mensaje=auxReg ?"Se edito correctamente":"Se registro correctamente"
                setTipoAdvertencia("success")      
                setMensaje(mensaje);                
                setAviso(false);
                toast.success(mensaje,{
                    pauseOnFocusLoss: false,                    
                    toastId: `nvo-afil${1}`
                })          
                getDatos(auxReg===1? 1:2)      
                setModalAbierto(false);
                setNvoRegistro(aux)
                serCambioEfectivo(true) 
            }
        }
        llamaApiCargaToken(data, url, respuesta,ErrorGeneral,setEspera,history,source);
    };

    const onChangeCorreo = e =>
	{   let expNopermitida = new RegExp('[%{}*|`]');  
        let expMenos = new RegExp("'");
        let expMas = new RegExp('"');             
        let expCadena = new RegExp('[A-Za-z0-9$@#_&-+()/.;!?,<>=]');  
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) && !expMenos.test(e.target.value) &&
            !expMas.test(e.target.value) ) || e.target.value===' '|| e.target.value==='') 
        { 
            setRegistro({
                    ...registro, 
                    [e.target.name] : e.target.value  
                })
            if (aviso) 
            {   setMensaje('');
                setAviso(false);
            }
        }		
	};    

    const mostrarPwd = () => {        
        setVisiblePwd(!visiblePwd)
    };
  
    const mostrarPwdUp = (event) => {
        event.preventDefault();        
    };

    const verificaNulos = (campo,descripcion)=>{
        let respuesta =false;                  
        if( campo===null || (typeof campo !== 'number' && typeof campo === 'string' 
            && (campo.trim() === '' || campo.trim() === null) )
        ) 
        {   respuesta=true;                                   
            setMensaje('No se lleno el campo '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }     

    const verificaPreg1 = (campo,descripcion)=>{
        let respuesta =false;        
          
        if( campo==="0" )
        
        {   respuesta=true;                                   
            setMensaje('Debe seleccionar una respuesta en '+descripcion);
            setTipoAdvertencia("warning")  
            setAviso(respuesta);
        }
        return(respuesta);
    }    

    const mandaAlerta=(mensaje,tipoAdvert)=>
    {
        setMensaje(mensaje);
        setTipoAdvertencia(tipoAdvert)  
        setAviso(true);      
    }
      
    function validaVariable(auxCampo,auxMensaje,auxTamanio) 
    {   let respuesta=false
        if ( !verificaNulos(auxCampo,auxMensaje) ) 
        {   if (auxCampo.length>=auxTamanio ) 
            {                
                respuesta=true                    
            }else
            {            
                mandaAlerta('Campo '+auxMensaje +' incompleto, debe escribir un '+ auxMensaje+' valido',"warning") 
            }
        }   
          
        return respuesta;
    }

    function valContra() {
        let respuesta=false
        if ( !verificaNulos(UsrPass,'Contraseña') ) 
        {            
            if (UsrPass.length>=4 ) 
            {   respuesta=true    
            }
            else
            {   mandaAlerta('Campo Contraseña incompleto, debe escribir una Contraseña valida',"warning") 
            }
        }        
        return respuesta;
    }
 
    function guardarDatos(e)
    {   e.preventDefault()                
        //serCambioEfectivo(true)          
        const auxFechaNacimient=moment( FNacimien).format('YYYY-MM-DD')  
        if (  !verificaNulos(Seccion,"Sección") &&
             validaVariable(Nombre,'Nombre',3)             
            && validaVariable(ApPat,'Apellido Paterno',3)&& validaVariable(ApMat,'Apellido Materno',3)    //  && validaVariable(Tel,'Telefono',10)            
            && validaVariable(Tel,'Teléfono',10) 
            && validaVariable(UsrNom,'Usuario',4) && valContra() 
            
            && !verificaNulos(Tipo,"¿Como participara en el Proyecto?")
            && !verificaNulos(Subtipo,"Tipo")
            && (Tipo===12 ?  !verificaNulos(Distrito,"Distrito"): true)
            && !verificaNulos(Participo,"¿Participó en elecciones anteriores?")
            && (Participo ==="0" || (Participo ==="1" && !verificaNulos(Partido,"Partido") ))
            
          )
        {           
            setMensaje('');                
            setAviso(false);                
            //  setBtnDeshabilitado(true)               
            const anios = moment().diff(auxFechaNacimient, 'years',false);                  
               
            llamadaNvoPerfil(auxFechaNacimient+'T00:00:00', anios)                               
        }                                  
    } 
      


    const onChangeDto=(e)=>{    
        if (e!== null && e!== undefined) 
        { //setMuniSelect(e)    
                        
            setRegistro({
                ...registro,
                Distrito :e.target.value,
                Otb:"" , Recinto:""
            })      
            setMensaje('');                
            setAviso(false); 
        }else
        {   setRegistro({
                ...registro,
                Distrito : "",
                Otb:"" , Recinto:""
            })           
        }       
        setListOtb([])
        setListRecinto([]) 
    }  

    const onChangeSel=(e)=>{
        if (e!== null && e!== undefined) 
        {  setRegistro({...registro,[e.target.name] : e.target.value})
        }else
        {setRegistro({...registro,[e.target.name] : 0})
        } 
        
    }
    
    const onChangeSelTP=(e)=>{
        if (e!== null && e!== undefined) 
        {  setRegistro({...registro,[e.target.name] : e.target.value, Subtipo:"", Distrito:""})
        }else
        {setRegistro({...registro,[e.target.name] : 0, Subtipo:"",Distrito:""})
        } 
        
    }    

        const guardarSeccionSelect = (e) => {
        if (e !== null && e !== undefined) {
            setRegistro({
                ...registro,
                Seccion: e.target.value
            })
            setMensaje('');
            setAviso(false);
        } else {
            setRegistro({
                ...registro,
                Seccion: ""
            })
        }
    }

    const onChangeRad=(e)=>{
        if (e.target.name==="Tipo") 
        {   setRegistro({...registro,[e.target.name] : e.target.value,
                Participo:"0",Partido:null
            })            
        }
        else
        {   if (e.target.name==="Participo") 
            {   setRegistro({...registro,[e.target.name] : e.target.value,
                    Partido:null
                })            
            }
            else
            {   setRegistro({...registro,[e.target.name] : e.target.value,                    
                })           
            }
            
        }                
    }

    const DatosGenerales=(
        <div>            
           <Box   pt={1} mb={1} display="flex" flexDirection={"row"}>
             {listSecc.length !== 0 ?
                    <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Seccion-label-nvo">Sección</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '7rem'}}
                            label="Sección" id="Seccion-select2" name="Seccion"
                            value={Seccion} onChange={guardarSeccionSelect}
                            fullWidth
                        >
                            {listSecc.map((seccion, index) => {
                                return (
                                <MenuItem size='small' value={seccion.Id} key={seccion.Id}>
                                    <em>{seccion.Numero}</em>
                                </MenuItem>
                                )
                                }
                            )}
                        </Select>
                    </FormControl>
                    : <FormControl size='small'>
                        <InputLabel size='small' variant="outlined" id="Seccion-label-nvo">Sección</InputLabel>
                        <Select size='small' variant="outlined" style={{width: '7rem'}} 
                            label="Sección" id="Seccion-select2" name="Seccion"
                            value={Seccion} onChange={guardarSeccionSelect}
                            fullWidth
                        >
                            <MenuItem size='small' value={''}>
                                <em></em>
                            </MenuItem>
                        </Select>
                    </FormControl>
                }
                <Box display={"flex"} flexDirection={"row"} ml={1}>
            
                 <FormControl component="fieldset" style={{marginLeft:.5+'rem' }}>          
                    <FormLabel  >Genero</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top"
                        name="genero" value={genero} onChange={onChangeRad}
                    >                        
                        <FormControlLabel value={"H"}  label={"H"}
                            style={{}}
                            control={<Radio color="primary" />} />
                        <FormControlLabel value={"M"}  label={"M"}
                            style={{}}
                            control={<Radio color="primary" />} />                                                                      
                    </RadioGroup>                     
                </FormControl>      
            </Box>           
         
                { /* listOtb.length!==0 ?                
                <Box display={"flex"} mb={1}>
                <FormControl size='small'  style={{ minWidth:14+'rem', marginLeft:".5rem"}} >
                    <InputLabel size='small' variant="outlined" id="Otb-label-nvo">OTB</InputLabel>
                    <Select  size='small' variant="outlined"  
                        label="OTB" id="Otb-select2" name="Otb"
                        value={Otb} onChange={onChangeSel}
                    >
                        {listOtb.map((secc, index) => {
                            if(secc.Id>0) {
                            return(
                            <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                <em>{`${secc.Numero} - ${secc.Nom}` }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                    </FormControl>
                    </Box>
                :   null */
                }
                { listRecinto.length!==0 ?                
                <Box display={"flex"} mb={1} ml={1}>
                <FormControl size='small'  style={{ minWidth:24+'rem', marginRight:".5rem"}} >
                    <InputLabel size='small' variant="outlined" id="Recinto-label-nvo">Recinto</InputLabel>
                    <Select  size='small' variant="outlined"  
                        label="Recinto" id="Recinto-select2" name="Recinto"
                        value={Recinto} onChange={onChangeSel}
                    >
                        {listRecinto.map((secc, index) => {
                            if(secc.id>0) {
                            return(
                            <MenuItem size='small' value={secc.id} key={secc.id}>
                                <em>{`${secc.nom}` }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                    </FormControl>
                    </Box>
                :   null
                }
               
            </Box>    
          
            {RelojFNacimiento()}
            <TextField required id="Nombre-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:10+'rem',marginRight:".5rem"}}
                label="Nombre" value={Nombre} name='Nombre'size="small" autoComplete='off' // defaultValue="Nombre"                
                //auxArrerror={arrError[3]} onBlur={()=>verifiNombre()}
            />
            <TextField required id="ApPat-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:10+'rem',marginRight:".5rem"}}
                label="Apellido Paterno" value={ApPat} name='ApPat'size="small" autoComplete='off'                 
            />
            <TextField required id="ApMat-input" onChange={onChange} style={{paddingBottom:.5+'rem',width:10+'rem'}}
                label="Apellido Materno" value={ApMat} name='ApMat'size="small" autoComplete='off'                 
            />
            <br/>            
                   
            <TextField  id="CInt-input" onChange={onChangeNumTel} style={{paddingRight:1+'rem',width:8+'rem'}}
                label="Teléfono" defaultValue="Tel" value={Tel} name='Tel' size="small" type="number"
                inputProps= {{ maxlength: 10 }} autoComplete='off'
            /> 
            <TextField  id="Email-input" onChange={onChangeCorreo} style={{paddingBottom:1+'rem',width:20+'rem'}}
                label="Email"  value={Email} name='Email' size="small" autoComplete='off'
            />  
            <br/>
            <TextField  id="Usu-input2" onChange={onChangeCorreo} autoComplete='off' required disabled={Llave!==0?true:false}
                label="Usuario"  value={UsrNom} name='UsrNom' size="small"//defaultValue="Usuario"
                style={{width:12.5+'rem',paddingRight:.8+'rem',paddingBottom:.5+'rem',}}
            />                 
            <FormControl  size="small" style={{width:12.5+'rem'}} required >
                <InputLabel htmlFor="input-pwd-usu" size="small">
                    Contraseña
                </InputLabel>
                <Input
                    id="input-pwd-usu"
                    type={visiblePwd ? 'text' : 'password'}
                    value={UsrPass}  autoComplete='off' name="UsrPass"
                    onChange={onChange } size="small"
                    endAdornment={
                        <InputAdornment position="end" size="small">
                            <IconButton size="small" 
                                aria-label="icono password visibility"
                                onClick={mostrarPwd}  onMouseDown={mostrarPwdUp}
                            >
                            {visiblePwd ? <Visibility size="small"/> : <VisibilityOff size="small"/>}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
            <br/>
            <Box display={"flex"} style={{marginBottom:"1rem",marginTop:"1rem"}} >
               {/*  <FormControl component="fieldset" style={{marginLeft:.5+'rem' }}>          
                    <FormLabel  >¿Como participara en el Proyecto?</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top"
                    name="Tipo" value={Tipo} onChange={onChangeRad}
                    >
                        {listNivelTp.map((elemnt)=>
                            <FormControlLabel value={elemnt.Id.toString()}  label={elemnt.desc}
                                style={{color:elemnt.Color}}
                                control={<Radio color="primary" />} /> 
                        )}                                                
                    </RadioGroup>                     
                </FormControl>   */}
                <FormControl size='small'  style={{minWidth:20.5+'rem',}} >
                    <InputLabel size='small' variant="outlined" id="Tipo-label-nvo">¿Como participara en el Proyecto?</InputLabel>
                    <Select  size='small' variant="outlined"
                        label="¿Como participara en el Proyecto?" id="Tipo-select2" name="Tipo"
                        value={Tipo} onChange={onChangeSelTP}
                    >
                        {listNivelTp.map((part, index) => {
                            if(part.Id>0) {
                            return(
                            <MenuItem size='small' value={part.Id} key={part.Id}>
                                <em>{part.Descr }</em>
                            </MenuItem>
                            )}
                        } )}                    
                    </Select>
                </FormControl>
                <FormControl size='small'  style={{ minWidth:9+'rem', marginLeft:".5rem"}} >
                        <InputLabel size='small' variant="outlined" id="Subtipo-label-nvo">Tipo</InputLabel>
                        <Select  size='small' variant="outlined" disabled={nvl===8 ?true:false}        
                            label="Tipo" id="Subtipo-select2" name="Subtipo"
                            value={Subtipo} onChange={onChangeSel}
                        >
                            {listSubTipo.map((subtp, index) => {
                                if(subtp.Id>0) {
                                return(
                                <MenuItem size='small' value={subtp.Id} key={subtp.Id}>
                                    <em>{subtp.desc }</em>
                                </MenuItem>
                                )}
                            } )}                    
                        </Select>
                </FormControl>
                {Tipo ===12 && listDistrito.length !== 0 ?                 
                    <Box display={"flex"} mb={1}>
                    <FormControl size='small'  style={{ minWidth:7+'rem', marginLeft:".5rem"}} >
                        <InputLabel size='small' variant="outlined" id="Distrito-label-nvo">Distrito</InputLabel>
                        <Select  size='small' variant="outlined"    
                            label="Distrito" id="Distrito-select2" name="Distrito"
                            value={Distrito} onChange={onChangeDto}
                        >
                            {listDistrito.map((secc, index) => {
                                if(secc.Id>0) {
                                return(
                                <MenuItem size='small' value={secc.Id} key={secc.Id}>
                                    <em>{secc.cadena }</em>
                                </MenuItem>
                                )}
                            } )}                    
                        </Select>
                        </FormControl>
                    </Box>
                : null                
                }
            </Box>
            <Box display={"flex"} mb={1}>
                {  <FormControl component="fieldset" style={{marginLeft:.5+'rem' }}>          
                    <FormLabel  >¿Participó en elecciones anteriores?</FormLabel>        
                    <RadioGroup  row aria-label="position"  defaultValue="top"
                        name="Participo" value={Participo} onChange={onChangeRad}
                    >                        
                        <FormControlLabel value={"0"}  label={"No"}
                            style={{}}
                            control={<Radio color="primary" />} />
                        <FormControlLabel value={"1"}  label={"Si"}
                            style={{}}
                            control={<Radio color="primary" />} />                                                                      
                    </RadioGroup>                     
                </FormControl>  
                
                }
                {  Participo !=="0"&& listPart.length!==0 ?                                
                    <FormControl size='small'  style={{marginLeft:1.6+'rem', minWidth:8.5+'rem',marginTop:".3rem"}} >
                        <InputLabel size='small' variant="outlined" id="Partido-label-nvo">Partido</InputLabel>
                        <Select  size='small' variant="outlined"
                            label="Partido" id="Partido-select2" name="Partido"
                            value={Partido} onChange={onChangeSel}
                        >
                            {listPart.map((part, index) => {
                                if(part.Id>0) {
                                return(
                                <MenuItem size='small' value={part.Id} key={part.Id}>
                                    <em>{part.Nom }</em>
                                </MenuItem>
                                )}
                            } )}                    
                        </Select>
                    </FormControl>
                    
                :   null
                }
            </Box>  
           {/*  <Box display={"flex"} mb={1}>
               
            </Box> */}
                
            <br/>
            {posicion.length!==0?
                <Box style={{width:30.8+'rem',height:12+'rem'}}>
                    
                    <MapaLeaf registro={posicion}/>
                    
                </Box>
            :
                <Typography variant='h6'>Dirección no disponible.
                    {" "+ mensajePos?mensajePos:""}
                </Typography>
            }
        </div> 
    )     

    const cerrarBorrar = () => {            
        setAviso(false);
        setModalAbierto(false);
        if (cambioEfectivo) 
        {   
        
        }
    };

    return (    
    <Modal
        titulo={titulo} modalAbierto={modalAbierto}
        setModalAbierto={setModalAbierto} guardarDatos={guardarDatos}
        mensaje={mensaje} tipoAdvertencia={tipoAdvertencia}
        aviso={aviso} btnDeshabilitado={btnDeshabilitado}
        setAviso={setAviso} tamanio={'md'} cargando={espera}     
        cerrarBorrar={cerrarBorrar}   
    >
        {DatosGenerales}
    </Modal>             
    )
}

export default ModalNvoEdit